module.exports = __webpack_public_path__ + "img/nurseries.96d7e4be.svg";